import React, { useState } from "react";
import Footer from "./Footer";
import "../css/contactus.scss";
import Header from "./Header";
import { Link } from "react-router-dom";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // 重置表单
    setFormData({
      name: "",
      email: "",
      phone: "",
      message: "",
    });
    alert("Thank you for your message! We'll get back to you soon.");
  };

  return (
    <div className="color-scheme color-scheme--scheme-1">
      <Header />

      <div className="contact-page">
        <div className="contact-container">
          {/* Left Section - Contact Information */}
          <div className="contact-info-section">
            <div className="intro-text">
              <p>
                Many questions can be answered on our <Link to="/faq">FAQ</Link>{" "}
                page. This is often the fastest way to find the answer to common
                questions.
              </p>
              <p>
                Need to contact us? No problem! Just use the guidelines below to
                help us respond to you faster.
              </p>
            </div>

            {/* Phone Section */}
            <div className="contact-method">
              <h2>Phone</h2>
              <p>
                To order by phone or to call Merz Apothecary, our retail store,
                call us at:
              </p>
              <p className="phone-number">
                (773) 989-0900 (10AM - 6PM CST, Monday through Saturday)
              </p>
            </div>

            {/* Email Section */}
            <div className="contact-method">
              <h2>Email</h2>
              <p>
                We answer our customer service email Monday through Friday, 10AM
                to 6PM CST. We generally respond within a few hours during those
                times. Emails sent outside of those hours will be responded to
                the following business day. Simply fill in the form to the right
                or reach us at{" "}
                <Link to="mailto:find@sadiemall.site">find@sadiemall.site</Link>
              </p>
            </div>

            {/* Chat Section */}
            <div className="contact-method">
              <h2>Chat</h2>
              <p>
                Our Customer Service team is available to Chat Monday through
                Friday, 10AM to 6PM CST. Click on the Chat icon on the bottom
                right of this screen to get started!
              </p>
            </div>

            {/* Mailing List Section */}
            <div className="contact-method">
              <h2>Join our Mailing List</h2>
              <p>
                Would you like to receive brochures, flyers and postcards from
                Sadiemall spotlighting our top brands and new arrivals? You can
                send us an email or Chat with us, indicating that you would like
                to be added to our mailing list.
              </p>
            </div>

            {/* Subscribe Section */}
            <div className="contact-method">
              <h2>Subscribe to Updates</h2>
              <p>
                If you would like to stay on top of the newest products, gifts
                with purchase, and other exciting special offers, subscribe to
                email or SMS updates !
              </p>
            </div>

            {/* Locations Section */}
            <div className="contact-method">
              <h2>Our Locations</h2>
              <div className="location">
                <p className="location-name">
                  <strong>Merz Apothecary</strong>
                </p>
                <p>4716 North Lincoln Avenue</p>
                <p>Chicago, IL 60625</p>
              </div>
              <div className="location">
                <p className="location-name">
                  <strong>The Shops at Merz</strong>
                </p>
                <p>4718 North Lincoln Avenue</p>
                <p>Chicago, IL 60625</p>
              </div>
            </div>
          </div>

          {/* Right Section - Contact Form */}
          <div className="contact-form-section">
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="name">Name</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">
                    Email <span className="required">*</span>
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="phone">Phone number</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  rows="6"
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>

              <button type="submit" className="submit-btn">
                SEND
              </button>
            </form>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Contact;
